import { Component, Input, OnInit } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import {
    CarrierRepsAssignedStats
} from '../../models/models';

@Component({
    selector: 'carrier-reps-assigned-stats-grid',
    templateUrl: './carrier-reps-assigned-stats-grid.component.html',
    standalone: false
})
export class CarrierRepsAssignedStatsGrid implements OnInit {
    @Input() quoteOrderLineID: number = 0;
    public isLoading: boolean = false;

    public carrierRepsAssignedStats: CarrierRepsAssignedStats[] = [];
    public gridData: GridDataResult = { data: [], total: 0 };
    //public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'employeeName' }] };
    public gridState: State = { sort: [{ dir: 'asc', field: 'employeeName' }] };

    constructor(private cseService: CSEService) {
    }

    ngOnInit() {
        this.getCarrierRepsAssignedStats();
    }

    private getCarrierRepsAssignedStats() {
        this.isLoading = true;
        this.cseService.getCarrierRepsAssignedStatsByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
            this.isLoading = false;
            var reps = result.resultCollection;
            reps = reps.sort((left, right): number => {
                if (left.employeeName < right.employeeName) return -1;
                if (left.employeeName > right.employeeName) return 1;
                return 0;
            });
            this.carrierRepsAssignedStats = reps;
            this.gridData = process(this.carrierRepsAssignedStats, this.gridState);
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.carrierRepsAssignedStats, this.gridState);
    }
}
